import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Redirect, withRouter } from 'react-router';
import { CREATE_AD, FETCH_INITIAL_FORM_DETAILS } from '../../redux/Ads';
import AdNewForm from './AdNewForm/AdNewForm';

const AdNew = (props) => {
  const { fetchInitialFormDetails, adDetails, redirectPromotion, adId, } = props;
  const { location: { search, }, } = props;
  const searchParams = new URLSearchParams(search);

  useEffect(() => {
    if (searchParams.get('accepted_offer_id')) {
      fetchInitialFormDetails(searchParams.get('accepted_offer_id'));
    }
  }, [fetchInitialFormDetails, searchParams.get('accepted_offer_id')]);

  const initialAdDetails = useMemo(() => {
    if (searchParams.get('accepted_offer_id')) {
      return adDetails;
    }

    return {};
  }, [adDetails, searchParams]);


  const initialValues = {
    vin: '',
    damage_unrepaired: false,
    heated_grips: false,
    box: false,
    windshield: false,
    abs: false,
    metailic_lacquer: false,
    ful_service_history: false,
    new_inspection: false,
    ...initialAdDetails,
  };

  const handleSubmit = (values) => {
    props.createAd(values);
  };

  if (redirectPromotion) {
    return <Redirect to={`/dashboard/ads/${adId}/promote`} />;
  }

  return (
    <div className="row">
      <AdNewForm onSubmit={handleSubmit} initialValues={initialValues} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    adId: get(state, ['ads', 'ad_data', 'id']),
    adDetails: get(state, ['ads', 'ad_data']),
    redirectPromotion: get(state, ['ads', 'redirectPromotion']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInitialFormDetails: (offerId) => dispatch(FETCH_INITIAL_FORM_DETAILS(offerId)),
    createAd: (data) => dispatch(CREATE_AD(data)),
  };
};

AdNew.propTypes = {
  fetchInitialFormDetails: PropTypes.func.isRequired,
  redirectPromotion: PropTypes.bool.isRequired,
  adDetails: PropTypes.object.isRequired,
  createAd: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  adId: PropTypes.number,
};

AdNew.defaultProps = {
  adId: 0,
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
  )(AdNew));
